import React from "react";
import PropTypes from "prop-types";

class IFrame extends React.Component {
	componentDidMount() {
		const { onMount } = this.props;

		// useful to track if this component has mounted to the DOM yet
		onMount && onMount();
	}

	render() {
		const { src, onMount, ...otherProps } = this.props;

		return <iframe src={src} className="formViewer" {...otherProps}></iframe>;
	}
}

IFrame.propTypes = {
	src: PropTypes.string.isRequired,
	onMount: PropTypes.func,
};

export default IFrame;
